import React from 'react';
import Navigation from '../navigation';
import Card from './card';

const months = ["January","February","March","April","May","June","July",
            "August","September","October","November","December"];

const generateYears = () => {
    const years = [];
    const thisYear = new Date().getFullYear();
    for (var i = 2021; i <= thisYear; i++) {
        years.push(i);
    }
    return years;
};

const years = generateYears();

const initialState = {
    name: '',
    description: '',
    pageState: 'normal',
    filteredUsers: [],
    selectedUser: undefined,
    showUserList: false,
    month: undefined,
    year: undefined,
    isSearching: false,
};

export default class Cheers extends React.Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {
        const { account } = this.props;
        const { users } = account;
        if (!account.email) {
            this.props.getAccount();
        }
        if (!users) {
            this.props.getUserList();
        }
        if (this.props.cheers === null) {
            this.props.getCheers();
        }
    }

    componentDidUpdate(newProps, prevState) {
        if (this.props.account.userList !== null && newProps.account.userList === null) {
            this.setState({ filteredUsers: this.props.account.userList });
        }
    }

    handleSubmit() {
        const { name, description } = this.state;
        if (name !== '' && description !== '') {
            this.props.createCheer(this.state);
            this.setState(initialState);
        }
    }

    _hasLikedPost(likes) {
        const { account } = this.props;
        return Boolean(likes.find(like => like.user === account._id));
    }

    handleNameUpdate(name) {
        const { userList } = this.props.account;
        if (this.state.selectedUser) {
            this.setState({ selectedUser: undefined });
        }
        if (name.trim() === '') {
            this.setState({
                name,
                showUserList: false,
                filteredUsers: userList,
                selectedUser: undefined,
            });    
        } else {
            const filteredUsers = userList.filter(user => {
                const againstName = `${user.firstName.toLowerCase().trim()}${user.lastName.toLowerCase().trim()}`;
                return againstName.includes(name.toLowerCase().trim().replace(/\s+/g, ''));
            });
            this.setState({ name, showUserList: true, filteredUsers });
        }
    }

    handleSearch() {
        const { month, year } = this.state;
        if (!year || !month) {
            return alert('Please select a month and year to search Cheers.');
        }
        if (year && month) {
            this.props.getCheerDates(year, month);
            this.setState({ isSearching: true });
        }
    }

    clearSearch() {
        this.setState({ isSearching: false });
        this.props.getCheers();
    }

    render() {
        const { cheers, account } = this.props;
        const isGroupedCheers = Boolean(cheers) && cheers["January"] !== undefined;
        const { pageState, showUserList, filteredUsers, selectedUser, isSearching, month, year } = this.state;
        return (
            <div>
                <Navigation {...this.props} />
                <div
                    className="px-8 py-12 relative"
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${require('../../assets/bg-1.jpg')})` }}>
                    <div className="bg-gradient-black-to-transparent"></div>
                    <div className="text-center">
                        <h2 className="relative text-center text-4xl lg:text-6xl text-white font-bold">Cheers for Peers</h2>
                        <p className="relative text-white text-lg lg:text-2xl text-center max-w-6xl mx-auto">Welcome to Cheers for Peers. Having you on the team makes all the difference. Thank you for bringing your best to work every single day. Here is a fast easy way to make a coworker’s day! See a peer going the extra mile? Send them a “cheers” to celebrate their hard work. Cheered employees will be entered into a quarterly raffle, five will win a small happy. Cheers!</p>
                        {pageState === 'normal' && Boolean(account) &&
                            <button
                                className="relative mt-8 font-bold p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                                onClick={() => this.setState({ pageState: 'new' })}>New Cheer
                            </button>
                        }
                    </div>
                </div>
                <div className="min-h-screen bg-gray-200 p-4">
                    {pageState !== 'new' &&
                        <div className="px-4">
                            <h3 className="mt-8 mb-2 text-gray-700">Archived Cheers</h3>
                            <span>
                                <select
                                    className="h-8 px-8 border-gray-300 border rounded"
                                    onChange={e => this.setState({ month: e.target.value })}>
                                    <option value="">Select month</option>
                                    {months.map(month => (
                                        <option key={month} value={month}>{month}</option>
                                    ))}
                                </select>
                            </span>
                            <span className="ml-2">
                                <select
                                    className="h-8 px-8 border-gray-300 border rounded"
                                    onChange={e => this.setState({ year: e.target.value })}>
                                    <option value="">Select year</option>
                                    {years.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </span>
                            <span onClick={() => this.handleSearch()} className="text-west-green cursor-pointer ml-2 underline">Search</span>
                        </div>
                    }
                    {pageState === 'normal' && Boolean(cheers) &&
                        <div>
                            {isSearching &&
                                <h3 className="mt-8 px-4 text-gray-700">Cheers from {month} {year} | <span onClick={() => this.clearSearch()} className="underline text-west-green cursor-pointer">View latest</span></h3>    
                            }
                            <div className="w-full">
                                {isSearching && cheers.length === 0 &&
                                    <div className="text-center text-2xl w-full text-gray-600 mt-8">No Cheers available for the selected time.</div>
                                }
                                {!isSearching && isGroupedCheers &&
                                    Object.keys(cheers).reverse().map(month => (
                                        <div key={month}>
                                            <div className="block font-bold text-gray-600 text-2xl pl-4 mt-8">{month}</div>
                                            <div className="flex flex-wrap">
                                                {cheers[month].map(item => (
                                                    <Card
                                                        expired={false}
                                                        key={item._id}
                                                        cheer={item}
                                                        deleteEntry={cheerId => this.props.deleteEntry(cheerId)}
                                                        removePostLike={(cheerId, postLike) => this.props.removePostLike(cheerId, postLike)}
                                                        likePost={cheerId => this.props.likePost(cheerId)}
                                                        iLike={() => this._hasLikedPost(item.likes)}
                                                        {...this.props} />
                                                ))}
                                            </div>
                                        </div>
                                    ))
                                }
                                {isSearching && !isGroupedCheers &&
                                    <div className="flex flex-wrap">
                                        {cheers.map(cheer => (
                                            <Card
                                                expired={false}
                                                key={cheer._id}
                                                cheer={cheer}
                                                deleteEntry={cheerId => this.props.deleteEntry(cheerId)}
                                                removePostLike={(cheerId, postLike) => this.props.removePostLike(cheerId, postLike)}
                                                likePost={cheerId => this.props.likePost(cheerId)}
                                                iLike={() => this._hasLikedPost(cheer.likes)}
                                                {...this.props} />
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {pageState === 'new' &&
                        <div className="max-w-3xl mx-auto mt-8">
                            <label className="relative block font-semibold text-gray-700" htmlFor="name">Name of person nominated
                                <input
                                    name="title"
                                    autoComplete="off"
                                    className="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                    type="text"
                                    value={Boolean(selectedUser) ? `${selectedUser.firstName} ${selectedUser.lastName}` : this.state.name}
                                    onChange={e => this.handleNameUpdate(e.target.value)}/>
                                    {showUserList === true &&
                                        <div className="absolute top-auto bg-white shadow-md p-2 px-4" style={{maxHeight: 280, overflow: 'auto'}}>
                                            {filteredUsers.map(usr => (
                                                <div className="cursor-pointer" onClick={() => this.setState({
                                                    selectedUser: usr,
                                                    showUserList: false,
                                                    name: `${usr.firstName} ${usr.lastName}`,
                                                })} key={usr.email}>{usr.firstName} {usr.lastName}</div>
                                            ))}
                                        </div>
                                    }
                            </label>
                            <label className="mt-6 block font-semibold text-gray-700" htmlFor="description">What do you want to nominate them for?</label>
                            <textarea
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                rows="6"
                                onChange={e => this.setState({ description: e.target.value })}></textarea>
                            <button
                                className="p-4 bg-transparent items-center text-gray-700 leading-none lg:rounded-full flex lg:inline-flex"
                                onClick={() => this.setState(initialState)}>Cancel</button>
                            <button
                                className={`mt-4 p-4 ${pageState === 'saving' ? 'bg-gray-600 cursor-not-allowed' : 'bg-west-green hover:bg-west-green-400'} items-center text-white leading-none lg:rounded-full flex lg:inline-flex`}
                                onClick={() => this.handleSubmit()}>{pageState === 'saving' ? 'Upload in progress..' : 'Submit cheer'}</button>
                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cheers/index.js